<template>
  <v-layout row wrap justify-space-around style="height: auto;">
    <v-flex xs12 md6 class="px-2">
      <v-card dark class="white">
        <v-card-title class="grey darken-4">
          <h3 class="headline">Reservas</h3>
        </v-card-title>
        <v-card-text class="black--text">
          Visualiza las reservas en un listado de cabañas.
        </v-card-text>
        <v-card-actions>
          <v-btn
            block color="light-green darken-1"
            dark @click="navigateTo('Reservas')">IR A RESERVAS</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex xs12 md6 class="px-2">
      <v-card dark class="white"
        :class="{
          'mt-3': $vuetify.breakpoint.smAndDown,
          'mt-0': $vuetify.breakpoint.mdAndUp,
        }"
      >
        <v-card-title class="grey darken-4">
          <h3 class="headline">Agenda</h3>
        </v-card-title>
        <v-card-text class="black--text">
          Visualiza las reservas en un calendario.
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            color="light-green darken-1"
            dark @click="navigateTo('Agenda')">IR A AGENDA</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import mixins from '@/mixins/mixins';

export default {
  mixins: [
    mixins,
  ],
};
</script>
